module.exports = __webpack_public_path__ + "static/img/cs-acceptance.273bfce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/cs-acceptance.svg
// module id = zow2
// module chunks = 20